module.exports = __webpack_public_path__ + "static/media/loadingBarraVermelhoV2.4e388765.svg";